import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'jsx/elements/inputs/Checkbox';

const CustomerTypeFilter = ({ onChange, filterValues, t }) => {
  return (
    <div className="form">
      <Checkbox
        name="company"
        id="company"
        value={filterValues.company}
        label={t('portfolio_filters_customerType_company')}
        onChange={onChange}
      />
      <Checkbox
        name="individual"
        id="individual"
        value={filterValues.individual}
        label={t('portfolio_filters_customerType_individual')}
        onChange={onChange}
      />
      <Checkbox
        name="deceased"
        id="deceased"
        value={filterValues.deceased}
        label={t('portfolio_filters_customerType_deceased')}
        onChange={onChange}
      />
    </div>
  );
};

CustomerTypeFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  filterValues: PropTypes.object.isRequired
};

export default CustomerTypeFilter;
